import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of, forkJoin } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { RolsExternal } from 'src/app/core/entities/rolsexternal.model';
import { RolsExternalService } from 'src/app/core/repositories/rolsexternal.service';
import { BOOLEAN_OPTION, DESHAB_EXTERNA_DESC, PETICIONES } from '../../../../../../../core/utils/constants';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { Texts } from 'src/app/core/entities/texts.model';

@Injectable()
export class EditDialogsRolExternalService {

    rolsExternal: RolsExternal = new RolsExternal();
    originalRolsExternal: RolsExternal = new RolsExternal();
    rolsExternalInput: RolsExternal = new RolsExternal();

    allRolsExternal: RolsExternal[] = [];
    changetitulo: boolean = false;

    enable: any[] = BOOLEAN_OPTION;
    text: Texts = new Texts();

    constructor(private rolsExternalService: RolsExternalService,
                private repositoryService: RepositoryService) { }

    /**
    * Inicia el dialog
    * @param data Datos recibidos por el dialog
    */
    init(data: any): Observable<boolean> {
        this.rolsExternal = data.rolsExternal;
        this.changetitulo = data.titulochange;
        this.originalRolsExternal = _.cloneDeep(this.rolsExternal);
        console.log(data);
        return forkJoin({
            valor0: this.rolsExternalService.findAll(),
            valor1: this.repositoryService.findByCode(PETICIONES.texts.findByCode, DESHAB_EXTERNA_DESC)
        }).pipe(map(dataGroup => {
            this.allRolsExternal = _.cloneDeep(dataGroup.valor0 as RolsExternal[]);
            this.text = _.cloneDeep(dataGroup.valor1);
            return true;
        }),catchError((error: any) => {
            console.log(error);           
            throw error;
        }));
    }

    /**
    * @description
    * Guarda el rol externo
    */
    public guardar(): Observable<any> {
        console.log('guardar');
        if (Utils.noUndfAndNull(this.rolsExternal.code, "")) {

        /*comparamos el rol externo original con el modificado*/
        let compareText = this.compare(this.rolsExternal, this.originalRolsExternal);

        if(compareText){
            return of(-1);
        }else{
            return this.rolsExternalService.postRolsExternal(this.rolsExternal);
        }

        } else {
            return this.rolsExternalService.postRolsExternal(this.rolsExternal);
        }
    }

    /**
    * @description
    * Comprueba si dos Roles externos son iguales.
    * @param datoX Rol externo 1
    * @param datoY Rol externo 2
    * @returns True si son iguales
    */
    public compare(itemX:RolsExternal, itemY:RolsExternal):boolean {
        //Ambos objetos están definidos y no son nulos
        if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

        if (itemX.enable !== null) {
            let value = itemX.enable.toString();
            if (value === 'null') {
                itemX.enable = 0;
            }
        }

        if(itemY.code == null){
            if (itemX.code !== "")
            return false;
        }else{
            if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
            || !Utils.compareTextOrNumber(itemX.descripcion, itemY.descripcion)
            || !Utils.compareTextOrNumber(itemX.enable, itemY.enable)
            ) && (itemX.code !== "" && Utils.noUndfAndNull(itemX.enable)))
            return false;
        }
        }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
        return false;
    }
    return true;
    }

    /**
    * @description
    * Asigna a las propiedades del servicio sus valores por defecto
    */
    build() {
        this.rolsExternal = new RolsExternal();
    }

}